import React from "react";
import { Icon } from "@iconify/react";

const SvgIcon = ({ name, className, onClick }) => {
  return <Icon icon={name} className={className} onClick={onClick} />;
};

export default SvgIcon;
